import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Store } from '@ngrx/store';
import { User } from '../../store/user';
import { AppState } from 'src/app/store/state';

import { AngularFirestore } from '@angular/fire/firestore';

@Component({
  selector: 'app-iep',
  templateUrl: 'account.page.html',
  styleUrls: ['account.page.scss']
})
export class AccountPage {

  user$: Observable<User>;
  uid: string;
  email: string;
  displayName: string;
  displayOffersLink: boolean = false;

  subscriptions: any;

  constructor(
     private router: Router,
     private afs: AngularFirestore,
     private store: Store<AppState>
   ) {
     this.user$ = this.store.select('user');
     this.user$.subscribe(data=>{

       console.log("DATA", data);

       this.uid = data['uid'];
       this.email = data['email'];
       this.displayName = data['displayName'];

       this.getSubscriptions().subscribe(data => {
         this.subscriptions = data;
         if (this.subscriptions.length ==0){
           this.displayOffersLink = true;
         } else {
           this.displayOffersLink = !this.subscriptions[0]['active'];
         }
       });
   })
 }

 getSubscriptions(){
    const now = new Date();
    return this.afs.collection('subscriptions')
      .doc('users')
      .collection(this.uid, ref => ref.orderBy('end', 'desc'))
      .snapshotChanges().pipe(
        map(data => {
          return data.map(s => {
            return {
              orderId: s.payload.doc.data()['orderId'],
              start: s.payload.doc.data()['start'],
              end: s.payload.doc.data()['end'],
              usd: s.payload.doc.data()['usd'],
              source: s.payload.doc.data()['source'],
              purchase: s.payload.doc.data()['purchase'],
              purchaseDate: s.payload.doc.data()['purchaseDate'],
              description: s.payload.doc.data()['productId'],
              active: (s.payload.doc.data()['end'].seconds * 1000 > now.getTime())
            };
          })
        }));
  }
}
